import styled from '@emotion/styled';
import { Icon, Stack, Text, tokens } from '@hotjar/hotsauce';
import { useTranslation } from '@hotjar/translations';

const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const Item = styled.li`
  margin-bottom: 8px;
`;

const CloseIcon = styled(Icon)`
  margin-right: 8px;
`;

type Props = {
  title: string;
  features: string[];
  testId: string;
};

export function MissingFeaturesList({ title, features, testId }: Props): JSX.Element {
  const { t } = useTranslation('voluntary-churn');

  return (
    <Stack direction="column" customSpacing={tokens.spacer.x2}>
      <Text as="span" textType="subtitle3" textColor="text_disabled">
        {title}
      </Text>
      <List data-testid={testId}>
        {features.map((feature) => (
          <Item key={feature}>
            <CloseIcon icon="close" color="text_danger" />
            <Text textType="body2">
              {t(`churn.deflection-modal.missing-features-list.${feature}`)}
            </Text>
          </Item>
        ))}
      </List>
    </Stack>
  );
}
